import React from "react";
import { Flex } from "../../../../../components/Flex";
import styled from "styled-components";
import { Text } from "../../../../../components/Text";
import { useTranslation } from "react-i18next";
import { Rounded } from "../../../../../theme/Rounded";
import { Spacing } from "../../../../../theme/Spacing";
import { CopyButton } from "../../../../../components/CopyButton";
import { useSettingsAIChatbotContext } from "../../../sections/SettingsAIChatBot";
import { Info } from "../../../../../components/Info";
import { AtiraImage } from "../../../../../components/Image";
import { Images } from "../../../../../assets";

const LinkContainer = styled(Flex)`
  background-color: ${({ theme }) => theme.sub};
  border-end-start-radius: ${Rounded.md};
  border-start-start-radius: ${Rounded.md};
  padding: ${Spacing.s};
  max-width: 100%;
  overflow: hidden;
`;

const CopyButtonWrapper = styled(Flex)`
  button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
`;

const StyledImage = styled(AtiraImage)`
  border: 1px solid ${({ theme }) => theme.main};
  border-radius: ${Rounded.sm};
`;

export const SettingsAIChatBotShareDrawerScript: React.FC = () => {
  const { t } = useTranslation();
  const { currentBot } = useSettingsAIChatbotContext();

  const generatedScript = `<script defer src="${process.env.REACT_APP_API_URL}/chatbot/${currentBot!._id}/generate/widget-mode"></script>`;

  return (
    <Flex flexDirection="column" gap="l">
      <Text fontWeight={"bold"}>
        {t("settings.aiChatbot.share.tabs.script.title")}
      </Text>
      <Info info={t("settings.aiChatbot.share.tabs.script.info")} />

      <Flex>
        <LinkContainer>
          <Text wordBreak="break-all" direction="ltr">
            {generatedScript}
          </Text>
        </LinkContainer>
        <CopyButtonWrapper>
          <CopyButton copy={generatedScript} asText />
        </CopyButtonWrapper>
      </Flex>

      <Flex flexDirection="column" gap="s">
        <Text>{t("common.example")}</Text>
        <StyledImage
          src={Images.AIChatbotScript2}
          alt="Chatbot Widget Example"
        />
        <StyledImage
          src={Images.AIChatbotScript1}
          alt="Chatbot Widget Example"
        />
      </Flex>
    </Flex>
  );
};
